import PageHeader from "components/PageHeader";
import styles from "./Sidebar.module.scss";
import classnames from "classnames";
import { useSelector } from "react-redux";

const sidebarMenu = [
  {
    name: "MY INFO",
    id: "my_info",
    permission: "my_info"
  },
  {
    name: "TEAMS",
    id: "teams",
    permission: "teams"
  },
  {
    name: "TEAM MEMBERS",
    id: "team_members",
    permission: "team_members"
  },
  {
    name: "SCHEDULES",
    id: "schedules",
    permission: "schedules"
  },
  {
    name: "SETTINGS",
    id: "settings",
    permission: "settings"
  },
];

const Sidebar = ({ setActive, active }) => {
  const permissions = useSelector((state) => state.permissions);
  
  // Filter menu items based on permissions
  const filteredMenu = sidebarMenu.filter(item => 
    permissions?.profile?.[item.permission]
  );

  return (
    <div className={styles.wrapper}>
      <PageHeader title="PROFILE" />

      <nav className={styles.menu}>
        <ul className={styles.menu_list}>
          {filteredMenu.map(({ name, id }) => {
            return (
              <li
                id={id}
                className={classnames(
                  styles.menu_item,
                  active === id ? styles.active : ""
                )}
                key={id}
                onClick={() => setActive(id)}
              >
                {name}
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
